// ADR-0003 D1: client-generated IDs.
//
// 15 characters, drawn from the PocketBase alphabet (`a-z` + `0-9`) so the
// offline record can be uploaded to PocketBase without remapping. We avoid
// timestamp prefixes — they leak clock skew and make ID lookups
// fingerprintable across users.

const ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";
const ALPHABET_LEN = ALPHABET.length;
const ID_LEN = 15;

export function newId(): string {
  const bytes = new Uint8Array(ID_LEN);
  crypto.getRandomValues(bytes);
  // Rejection-sample to remove modulo bias: each random byte in [0, 256) maps
  // uniformly into [0, ALPHABET_LEN) only if we discard values >= floor(256/N)*N.
  const limit = Math.floor(256 / ALPHABET_LEN) * ALPHABET_LEN;
  let out = "";
  while (out.length < ID_LEN) {
    if (bytes.length === 0) {
      crypto.getRandomValues(bytes);
    }
    const b = bytes[0]!;
    bytes[0] = 0;
    // Compact: shift the buffer left by one.
    for (let i = 1; i < bytes.length; i++) bytes[i - 1] = bytes[i]!;
    bytes[bytes.length - 1] = 0;
    if (b < limit) {
      out += ALPHABET[b % ALPHABET_LEN];
    }
  }
  return out;
}
